export default __webpack_public_path__ + "static/media/1.b46b85c0.png";